import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { INTEGRATIONS_OPENED, INTEGRATIONS_CONNECTION_BOTANALYTICS_OPENED, INTEGRATIONS_CONNECTION_BOTANALYTICS_CONFIGURATION_ADD_SAVED, INTEGRATIONS_CONNECTION_BOTANALYTICS_CONFIGURATION_CHANGES_SAVED, INTEGRATIONS_CONNECTION_WEBHOOK_OPENED, INTEGRATIONS_CONNECTION_WEBHOOK_CONFIGURATION_ADD_SAVED, INTEGRATIONS_CONNECTION_WEBHOOK_CONFIGURATION_CHANGES_SAVED, INTEGRATIONS_CONNECTION_RDSTATION_OPENED, INTEGRATIONS_CONNECTION_RDSTATION_CONFIGURATION_ADD_SAVED, INTEGRATIONS_CONNECTION_RDSTATION_CONFIGURATION_CHANGES_SAVED, INTEGRATIONS_CONNECTION_DASHBOT_OPENED, INTEGRATIONS_CONNECTION_DASHBOT_CONFIGURATION_ADD_SAVED, INTEGRATIONS_CONNECTION_DASHBOT_CONFIGURATION_CHANGES_SAVED, INTEGRATION_CONNECTION_RDSTATION_CONFIGURATION_INSTALL_CLICKED, INTEGRATION_CONNECTION_RDSTATION_CONFIGURATION_UNINSTALL_CLICKED, INTEGRATIONS_CONNECTION_HUBSPOT_OPENED, } from './IntegrationsSegmentEvents';
export class IntegrationsSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    page() {
        this.SegmentService.page({
            name: 'Builder',
            path: window.location.hash,
        });
    }
    trackOpened(payload, success) {
        this.trackEvent(INTEGRATIONS_OPENED, payload, success);
    }
    trackConnectionOpened(integrationName, payload, success) {
        const connectionOpenedEventName = {
            'botanalytics': INTEGRATIONS_CONNECTION_BOTANALYTICS_OPENED,
            'webhook': INTEGRATIONS_CONNECTION_WEBHOOK_OPENED,
            'dashbot': INTEGRATIONS_CONNECTION_DASHBOT_OPENED,
            'hubspot': INTEGRATIONS_CONNECTION_HUBSPOT_OPENED,
        };
        const integrationEventName = connectionOpenedEventName[integrationName];
        if (integrationEventName) {
            this.trackEventWithUserProperty(integrationEventName, payload, success);
        }
    }
    trackConnectionBotanalyticsConfigurationAddSaved(payload, success) {
        this.trackEvent(INTEGRATIONS_CONNECTION_BOTANALYTICS_CONFIGURATION_ADD_SAVED, payload, success);
    }
    trackConnectionBotanalyticsConfigurationChangesSaved(payload, success) {
        this.trackEventWithUserProperty(INTEGRATIONS_CONNECTION_BOTANALYTICS_CONFIGURATION_CHANGES_SAVED, payload, success);
    }
    trackConnectionWebhookConfigurationAddSaved(payload, success) {
        this.trackEvent(INTEGRATIONS_CONNECTION_WEBHOOK_CONFIGURATION_ADD_SAVED, payload, success);
    }
    trackConnectionWebhookConfigurationChangesSaved(payload, success) {
        this.trackEventWithUserProperty(INTEGRATIONS_CONNECTION_WEBHOOK_CONFIGURATION_CHANGES_SAVED, payload, success);
    }
    trackConnectionRdstationOpened(payload, success) {
        this.trackEventWithUserProperty(INTEGRATIONS_CONNECTION_RDSTATION_OPENED, payload, success);
    }
    /**
     * @deprecated Must be removed when rd-station-o-auth feature toggle is removed
     */
    trackConnectionRdstationConfigurationAddSaved(payload, success) {
        this.trackEvent(INTEGRATIONS_CONNECTION_RDSTATION_CONFIGURATION_ADD_SAVED, payload, success);
    }
    /**
     * @deprecated Must be removed when rd-station-o-auth feature toggle is removed
     */
    trackConnectionRdstationConfigurationChangesSaved(payload, success) {
        this.trackEventWithUserProperty(INTEGRATIONS_CONNECTION_RDSTATION_CONFIGURATION_CHANGES_SAVED, payload, success);
    }
    trackConnectionRdStationConfigurationInstallClicked(payload, success) {
        this.trackEventWithUserProperty(INTEGRATION_CONNECTION_RDSTATION_CONFIGURATION_INSTALL_CLICKED, payload, success);
    }
    trackConnectionRdStationConfigurationUninstallClicked(payload, success) {
        this.trackEventWithUserProperty(INTEGRATION_CONNECTION_RDSTATION_CONFIGURATION_UNINSTALL_CLICKED, payload, success);
    }
    trackConnectionDashbotConfigurationAddSaved(payload, success) {
        this.trackEvent(INTEGRATIONS_CONNECTION_DASHBOT_CONFIGURATION_ADD_SAVED, payload, success);
    }
    trackConnectionDashbotConfigurationChangesSaved(payload, success) {
        this.trackEventWithUserProperty(INTEGRATIONS_CONNECTION_DASHBOT_CONFIGURATION_CHANGES_SAVED, payload, success);
    }
    trackUserProperty(payload) {
        this.SegmentService.setAccount(payload);
    }
    trackEvent(event, payload, success) {
        this.SegmentService.createBotTrack(event, this.application, { ...payload, Status: this.eventStatus(success) });
    }
    trackEventWithUserProperty(event, payload, success) {
        this.trackUserProperty();
        this.trackEvent(event, payload, success);
    }
    eventStatus(success) {
        if (success === undefined) {
            return;
        }
        return success ? SUCCESS_STATUS : FAILURE_STATUS;
    }
}
IntegrationsSegmentService.$inject = ['SegmentService'];
